import Vue from 'vue'
import create from './create'
import createWizard from './createWizard'
import edit from './edit/index'
import search from './search'
import searchWizard from './searchWizard'
import {urlEncode} from 'src/utilities/utils'
import {make} from 'vuex-pathify'
import {ptracGet, ptracGetEntities, ptracGetEntity} from 'src/utilities/ptracApi'

const initialState = {
  types: []
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)
getters.types = (state) => {
  return state.types
}

const mutations = make.mutations(state)

mutations.types = (state, payload) => {
  state.types = payload
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchExistsByName({}, name) {
      return await ptracGetEntity('projects/search/existsByNameIgnoreCase?name=' + urlEncode(name))
    },
    async fetchFindByStreetName({}, streetName) {
      return await ptracGetEntities('projects/search/findByAddressStreetName?streetName=' +  urlEncode(streetName))
    },
    async fetchByName({}, name) {
      return await ptracGetEntity('projects/search/findOneByNameIgnoreCase?name=' + urlEncode(name))
    },
    async fetchExistsByAddressCity({}, city) {
      return await ptracGet('projects/search/existsByAddressCityIgnoreCase?city=' + urlEncode(city.name))
    },
    async fetchExistsByLegalSubdivisionId({}, legalSubdivisionId) {
      return await ptracGet('projects/search/existsByAddressLegalSubdivisionId?legalSubdivisionId=' + legalSubdivisionId)
    },
    async fetchByIds({}, projectIds) {
      return await ptracGet('/projects/findByIdIn?ids=' + projectIds)
    },
    async fetchById({}, id) {
      return await ptracGet('projects/' + id)
    }
  },
  modules: {
    create,
    createWizard,
    edit,
    search,
    searchWizard
  }
}
